<div *ngIf="!isStaticRoute()" class="root-container">
  <div *ngIf="partnerLoaded()" class="root-content-container">
    <div *ngIf="themeLoaded()" [class.home-layout]="isHomePage()">
      <header-component
        *ngIf="showHeader"
        [brandSrcPath]="partnerLogoUrl()"
        [counter]="productCount()"
        [productData]="productData"
        (linkClicked)="handleLinkClicked($event)"
      />
      <router-outlet />
      <footer-component
        class="footer"
        [epIconSrcPath]="epIconSrcPath"
        [valIconSrcPath]="valIconSrcPath"
        [impressUrl]="impressUrl"
        (linkClicked)="handleLinkClicked($event)"
      />
    </div>
  </div>
</div>
<div *ngIf="isStaticRoute()" class="root-container">
  <div class = root-content-container>
    <router-outlet></router-outlet>
    <footer-component
      class="footer"
      [epIconSrcPath]="epIconSrcPath"
      [valIconSrcPath]="valIconSrcPath"
      [impressUrl]="impressUrl"
      (linkClicked)="handleLinkClicked($event)"
      />
  </div>
</div>
